module.exports = __webpack_public_path__ + "static/media/lumio_beta.ab7f60ed.png";